import Spinner from '../../components/Spinner/Spinner';

const Logout = () => (
  <div className='min-h-screen bg-white dark:bg-dark-bold'>
    <Spinner show />
  </div>
);

export default Logout;
